import React from 'react';
import styled from 'styled-components';
import MessageIcon from '../ui/MessageIcon';
import {
  TooltipWrapper as DefaultTooltipWrapper,
  Tooltip as DefaultTooltip,
  NotificationButton as DefaultNotificationButton,
} from '../../styles/navigation/NavbarStyles';

const NotificationIconWrap = styled.span`
  position: relative;
  contain: layout;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  line-height: 0;
`;

function ChatNotificationButton({
  toggleChat,
  unreadCount,
  NotificationButton = DefaultNotificationButton,
  TooltipWrapper = DefaultTooltipWrapper,
  Tooltip = DefaultTooltip,
}) {
  return (
    <TooltipWrapper>
      <NotificationButton
        onClick={toggleChat}
        aria-label={unreadCount > 0 ? `Open messages, ${unreadCount} unread` : 'Open messages'}
        type="button"
      >
        <NotificationIconWrap>
          <MessageIcon />
          {unreadCount > 0 && (
            <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </NotificationIconWrap>
      </NotificationButton>
      <Tooltip>Messages</Tooltip>
    </TooltipWrapper>
  );
}

export default ChatNotificationButton;
